import registrationSteps from 'frontend/unpoly/javascripts/modules/registration_steps'
import { trackOnNextPage } from '../tracking'
import { trackEvent } from '../util/analytics'

interface RegistrationStepFormData {
  registrationStep: string
  subjectAreaIdAndKeyByStudyCourseId: Record<string, any>
}

up.compiler(
  '[data-registration-step-form]',
  (element: HTMLFormElement, data: RegistrationStepFormData) => {
    const registrationStep = data.registrationStep
    trackEvent('registration.stepShown', { stepName: registrationStep })

    // We submit the form via Unpoly ourselves so we receive its promise.
    // When the form was submitted successfully, the promise will be fulfilled, and we can write to the session.
    element.addEventListener('submit', (event: Event) => {
      void submitAndUpdateSession()
      up.event.halt(event)
    })

    function onSaved(params: Record<string, string>, { leaving }: { leaving: boolean }): void {
      registrationSteps.configureSubjectAreaMapping(data.subjectAreaIdAndKeyByStudyCourseId)
      registrationSteps.onSave(registrationStep, params)
      const push = leaving ? trackOnNextPage : trackEvent
      push('registration.stepCompleted', { stepName: registrationStep })
    }

    async function submitAndUpdateSession(): Promise<void> {
      const params = up.Params.fromForm(element).toObject()
      // A saved step can lead into the Inertia app (the sign up page). Unpoly then loads that page in full
      // (unpoly_inertia_pages.ts) and the submit never settles, so the save is handled when its response comes in.
      let savedLeaving = false
      const stopWatching = up.on('up:fragment:loaded', (event) => {
        if (event.response.header('X-Inertia-Page') && event.response.ok) {
          savedLeaving = true
          onSaved(params, { leaving: true })
        }
      })
      try {
        await up.submit(element)
        if (!savedLeaving) onSaved(params, { leaving: false })
      } catch {
        // Save failed. No need to update the session.
      } finally {
        stopWatching()
      }
    }
  },
)
